// extracted by mini-css-extract-plugin
export default {"container":"TasksCard_container__E88Uz","row":"TasksCard_row__nPuGW","bullet":"TasksCard_bullet__4S5p6","task":"TasksCard_task__ocE6J","checkbox":"TasksCard_checkbox__96ube"};